import React from 'react';
import Tag from './Tag';
import Group from './Group';
import CheckableTag from './CheckableTag';
import { FSTagProps, TagDecorator } from './interface';

const TagCopy = Tag as React.FC<FSTagProps>;

Object.assign(TagCopy, {
  Group,
  CheckableTag,
});

export default TagCopy as TagDecorator;